'use client';

import { useState } from 'react';

interface MobileShareButtonProps {
  title: string;
  url: string;
}

export default function MobileShareButton({ title, url }: MobileShareButtonProps) {
  const [copied, setCopied] = useState(false);

  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({ title, url });
      } catch {}
      return;
    }

    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {}
  };

  return (
    <button
      className="share-btn share-btn-mobile"
      onClick={handleShare}
      aria-label="Share this article"
    >
      {copied ? '✓' : '↗'}
    </button>
  );
}
